type CookieToggleProps = {
  id: string;
  label: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

export const CookieToggle = ({ id, label, description, checked, disabled = false, onChange }: CookieToggleProps) => {
  return (
    <div className="border-b border-gray-200 py-5 last:border-b-0">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900">{label}</h3>
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        </div>
        <label
          htmlFor={id}
          className={`relative inline-flex cursor-pointer items-center ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
        >
          <input
            type="checkbox"
            id={id}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
            className="peer sr-only"
          />
          <div
            className={`peer-checked:bg-primary peer-focus:ring-primary h-7 w-12 rounded-full bg-gray-300 peer-focus:ring-2 peer-focus:ring-offset-2 after:absolute after:top-0.5 after:left-0.5 after:h-6 after:w-6 after:rounded-full after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-5 ${disabled ? "" : "peer-checked:peer-hover:bg-primary-dark peer-hover:bg-gray-400"} `}
          />
        </label>
      </div>
    </div>
  );
};
